<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form-model @keydown.enter.native="searchQuery" @submit.native.prevent layout="inline">
        <a-row :gutter="24">
          <a-col :span="5">
            <a-form-model-item label="供水流域">
              <j-dict-select-tag
                @change="searchQuery"
                dictCode="`iwt-wf`.dev_process,process_name,id, del_flag = '0' order by sort"
                placeholder="请选择供水流域"
                v-model="queryParam.devProcessId"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="5">
            <a-form-model-item label="设备名称">
              <a-input placeholder="请输入设备名称" v-debounce="searchQuery" v-model="queryParam.devName"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="5">
            <a-form-model-item label="表号">
              <a-input placeholder="请输入表号" v-debounce="searchQuery" v-model="queryParam.devTag"></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :md="3" :sm="5">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" @keyup.enter.native="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <a-button @click="handleExportXls('设备台账')" icon="download" type="primary">导出</a-button>
      <a-upload
        :action="importExcelUrl"
        :headers="tokenHeader"
        :multiple="false"
        :showUploadList="false"
        @change="handleImportExcel"
        name="file"
      >
        <a-button icon="import" type="primary">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
          <a-menu-item @click="batchCopy" key="2">
            <a-icon type="copy" />复制
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :scroll="{ x: true }"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <span slot="devModelSlot" slot-scope="text, record">
          <a-button @click="handleDevModalDetail(record)" size="small" type="link" v-if="!!text">{{ text }}</a-button>
        </span>

        <span slot="devTagSlot" slot-scope="text, record">
          <a-button @click="getDevDisplay(record)" size="small" type="link" v-if="!!text">{{ text }}</a-button>
        </span>

        <span @click="ShowLocationOnmap(record)" slot="locationSlot" slot-scope="text, record">
          <a-icon type="environment" />
          {{text}}
        </span>

        <span slot="runStatusSlot" slot-scope="text, record">
          <a-tag
            :color="record.runStatus === 'alert' ? '#9e9e9e' : record.runStatus === 'busy' ? '#faad14' : '#52c41a'"
          >
            {{
            $filterDictTextByCache('device_run_status', record.runStatus)
            }}
          </a-tag>
        </span>

        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>
        <template slot="pcaSlot" slot-scope="text">
          <div>{{ getPcaText(text) }}</div>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record, $event)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleDetail(record)">详情</a>
          <a-divider type="vertical" />
          <a @click="handleControl(record)">控制</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="generateWfPoints(record)">生成测点</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleRetire(record)">换新</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleCopy(record)">复制</a>
              </a-menu-item>
              <a-menu-item v-has="'tenant:test'">
                <a @click="handleService(record)">生产投运</a>
              </a-menu-item>

              <a-menu-item v-has="'user:yw'">
                <a @click="editRunStatus(record)">{{record.runStatus === 'alert' ? '状态正常' : '设置故障' }}</a>
              </a-menu-item>

              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <dev-list-modal @ok="modalFormOk" ref="modalForm"></dev-list-modal>

    <dev-model-modal-drawer ref="modelModalForm"></dev-model-modal-drawer>

    <dev-life-cycle-modal ref="devLifeModal"></dev-life-cycle-modal>

    <device-control-modal ref="devControlModal"></device-control-modal>

    <t-map-point-picker
      :default-center="[116.40, 39.90]"
      :default-zoom="12"
      @change="locationChange"
      ref="pointPicker"
    />

    <device-service-modal ref="devServiceModal" @ok="modalFormOk"></device-service-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import DevListModal from './modules/DevListModal'
  import DevLifeCycleModal from './modules/DevLifeCycleModal'
  import DevModelModalDrawer from '@/views/equipment/account/vue/modules/DevModelModalDrawer'
  import { getAction, postAction, putAction } from '../../../../api/manage'
  import { DragTableMixin } from '@/mixins/DragTableMixin'
  import { omit } from 'lodash'
  import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
  import JTreeSelectDevice from '@/components/jeecg/JTreeSelectDevice'
  import DeviceControlModal from './modules/DeviceControlModal'
  import DeviceServiceModal from './modules/DeviceServiceModal.vue'
  import Area from '@/components/_util/Area'
  import TMapPointPicker from '@/components/map/TMapPointPicker'
  import coordTransform from '@/utils/coordTransform';

  export default {
    name: 'DevListList',
    mixins: [DragTableMixin, JeecgListMixin, mixinDevice],
    components: {
      DevListModal,
      JTreeSelectDevice,
      DevModelModalDrawer,
      DevLifeCycleModal,
      DeviceControlModal,
      DeviceServiceModal,
      TMapPointPicker
    },
    data () {
      return {
        description: '设备台账管理页面',
        // 表头
        columns: [
          {
            title: '设备名称',
            align: 'center',
            dataIndex: 'devName',
            sorter: true
          },
          //   {
          //     title: '设备身份编号',
          //     align: 'center',
          //     dataIndex: 'devCode',
          //     sorter: true
          //   },
          {
            title: '表号',
            align: 'center',
            dataIndex: 'devTag',
            scopedSlots: { customRender: 'devTagSlot' },
            sorter: true
          },
          {
            title: '设备类型',
            align: 'center',
            dataIndex: 'devClassCode_dictText',
            sorter: true
          },
          {
            title: '设备型号',
            align: 'center',
            dataIndex: 'devTypeId_dictText',
            scopedSlots: { customRender: 'devModelSlot' },
            sorter: true
          },
          {
            title: '区域',
            align: 'center',
            dataIndex: 'region',
            sorter: true,
            scopedSlots: { customRender: 'pcaSlot' }
          },
          {
            title: '安装位置',
            align: 'left',
            dataIndex: 'location',
            scopedSlots: { customRender: 'locationSlot' },
            sorter: true
          },
          {
            title: '供水流域',
            align: 'center',
            dataIndex: 'areaName',
            sorter: true
          },
          {
            title: '设备状态',
            align: 'center',
            dataIndex: 'runStatus',
            // customRender: function (text) {
            //   return filterDictTextByCache('device_run_status', text)
            // },
            scopedSlots: { customRender: 'runStatusSlot' },
            sorter: true
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            fixed: 'right',
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        isorter: {
          column: 'sort',
          order: 'asc'
        },
        queryParam: {
          devName: '',
          devClassId: '',
          parentId: ''
        },
        url: {
          list: '/device/devList/list',
          delete: '/device/devList/delete',
          deleteBatch: '/device/devList/deleteBatch',
          exportXlsUrl: '/device/devList/exportXls',
          importExcelUrl: 'device/devList/importExcel',
          sort: '/device/devList/editSort',
          add: '/device/devList/add',
          edit: '/device/devList/edit',
          generateWfPoints: '/device/devList/generateWfPoints',
        },
        listPagination: {
          pageSize: 50,
          pageSizeOptions: ['50', '100', '200', '300']
        },
        modelSettings: {
          name: '设备型号',
          displayKey: 'modelName',
          valueKey: 'id',
          returnKeys: ['id', 'modelName'],
          listUrl: '/device/devModel/list',
          queryParamCode: 'modelName',
          queryParamText: '设备型号',
          columns: [
            { title: '型号名称', dataIndex: 'modelName', align: 'center' },
            // devCode

            {
              title: '型号编码',
              align: 'center',
              dataIndex: 'modelCode'
            },
            {
              title: '运行寿命',
              align: 'center',
              dataIndex: 'runningLife'
            }
          ]
        },
        dictOptions: {},
        superFieldList: [],
        devModelList: [],
        detailRouteName: 'FusionDevice',
        pageType: 1,
        deviceAddAttr: {
          devName: 'name',
          devTag: '2',
          parentId: '1538171098930270209',
          devClassId: '6A9OC55DC4D4467CA23DEF1CE37B0059',
          devProcessId: '1521373906911895553',
          areaId: '1521415028513701890',
          serviceStatus: '1'
        },
        pcaData: ''
      }
    },
    created () {
      this.pcaData = new Area()
      this.getSuperFieldList()
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
      }
    },
    methods: {
      // 打印 列表切换
      handlePrint () {
        this.pageType = !this.pageType
      },
      async handleModeQuery () {
        if (this.queryParam.devTypeId) this.queryParam.devTypeId = ''
        this.devModelList = []

        const { success, result } = await getAction('/device/devModel/queryByDevClassId', {
          devClassCode: this.queryParam.devClassCode
        })
        if (success) {
          this.devModelList = result
        }
      },
      handleClassChange (v) {
        this.handleModeQuery(v)
        this.searchQuery()
      },
      handleDevModalDetail (record) {
        this.$refs.modelModalForm.edit({ id: record.devTypeId })
        this.$refs.modelModalForm.title = '设备型号详情'
        this.$refs.modelModalForm.disableSubmit = true
      },
      initDictConfig () { },
      getSuperFieldList () {
        let fieldList = []
        this.superFieldList = fieldList
      },
      handleDetail (record) {
        this.$bus.$emit('to-page-detail', {
          name: 'FusionDevice',
          id: record.id,
          type: 'drawer'
        })
      },
      handleControl (record) {
        this.$refs.devControlModal.edit({ id: record.id })
        this.$refs.devControlModal.title = `设备控制-【${record.devName}】`
      },
      batchCopy () {
        if (this.selectedRowKeys.length <= 0) {
          this.$message.warning('请选择一条记录！')
        } else {
          var that = this
          this.$confirm({
            title: '确认复制',
            content: '是否复制选中设备数据?',
            onOk: function () {
              that.loading = true
              const selectData = that.selectionRows.map(rows => {
                rows.devTag += '_copy'
                rows.id = null
                return rows
              })
              postAction('/device/devList/batchInsert', selectData)
                .then(res => {
                  if (res.success) {
                    // 重新计算分页问题
                    that.reCalculatePage(that.selectedRowKeys.length)
                    that.$message.success('复制成功')
                    that.loadData()
                    that.onClearSelected()
                  } else {
                    that.$message.warning(res.message)
                  }
                })
                .finally(() => {
                  that.loading = false
                })
            }
          })
        }
      },
      handleCopyData (record) {
        this.copyData = record
      },
      // 复制
      handleCopy (record) {
        const that = this
        const selectData = omit(record, ['id'])
        selectData.devTag += '_copy'
        postAction(that.url.add, selectData)
          .then(res => {
            if (res.success) {
              // 重新计算分页问题
              that.reCalculatePage(that.selectedRowKeys.length)
              that.$message.success('复制成功')
              that.loadData()
              that.onClearSelected()
            } else {
              that.$message.warning(res.message)
            }
          })
          .finally(() => {
            that.loading = false
          })
      },
      handleRetire (record) {
        if (!record.devTag) {
          this.$message.warning('设备换新需要有设备表号进行定位')
          return
        }
        record.factoryDate = null
        record.factoryNumber = null
        record.operationDate = null

        this.$refs.modalForm.retire(record)
        this.$refs.modalForm.title = '换新'
        this.$refs.modalForm.disableSubmit = false
      },
      handleService (record) {
        this.$refs.devServiceModal.disableSubmit = false
        this.$refs.devServiceModal.edit(record);
      },
      editRunStatus (record) {
        record.runStatus = record.runStatus === 'alert' ? 'free' : 'alert';
        putAction(this.url.edit, { id: record.id, runStatus: record.runStatus })
          .then(res => {
            if (res.success) {
              this.loadData()
            } else {
              this.$message.warning(res.message)
            }
          })
      },
      getDevDisplay (record) {
        this.$refs.devLifeModal.show(record.devTag)
      },
      ShowLocationOnmap (record) {
        this.editRecord = record;
        let point = null;
        if (record.coordinateWgs84) {
          point = record.coordinateWgs84.split(',').map(Number);
        } else if (record.coordinateGcj02) {
          const gcj02 = record.coordinateGcj02.split(',').map(Number);
          point = coordTransform.gcj02ToWgs84(gcj02[0], gcj02[1]);
        }
        this.$refs.pointPicker.open({
          point,
          address: record.location
        });
      },
      locationChange (data) {
        if (!data) {
          return;
        }
        this.editRecord = { ...this.editRecord, location: data.address, coordinateGcj02: data.coordinateGcj02.join(','), coordinateWgs84: data.coordinateWgs84.join(','), region: data.region };
        putAction(this.url.edit, this.editRecord)
          .then(res => {
            if (res.success) {
              this.loadData()
            } else {
              this.$message.warning(res.message)
            }
          })
      },
      generateWfPoints (record) {
        const that = this
        postAction(this.url.generateWfPoints, { id: record.id, devTag: record.devTag })
          .then(res => {
            if (res.success) {
              that.$message.success(res.message)
            } else {
              that.$message.warning(res.message)
            }
          })
      },
      getPcaText (code) {
        return this.pcaData.getText(code);
      },
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>
